import type { NodeTypes } from '@xyflow/react';
import { BaseNode as BaseNodeComponent } from './BaseNode';
import { TriggerNode as TriggerNodeComponent } from './TriggerNode';
import { EmailNode as EmailNodeComponent } from './EmailNode';
import { TaskNode as TaskNodeComponent } from './TaskNode';
import { AutomationStepNodeWrapper as AutomationStepNodeWrapperComponent } from './AutomationStepNodeWrapper';
import { ConditionNode as ConditionNodeComponent } from './ConditionNode';
import { ErrorNode as ErrorNodeComponent } from './ErrorNode';

export { BaseNodeComponent as BaseNode };
export { TriggerNodeComponent as TriggerNode };
export { EmailNodeComponent as EmailNode };
export { TaskNodeComponent as TaskNode };
export { AutomationStepNodeWrapperComponent as AutomationStepNodeWrapper };
export { ConditionNodeComponent as ConditionNode };
export { ErrorNodeComponent as ErrorNode };

/**
 * Node type registry for React Flow.
 * Maps node type strings to their corresponding React components.
 * The NodeTypes type from @xyflow/react ensures compatibility with React Flow's internal type system.
 */
export const nodeTypes: NodeTypes = {
	trigger: TriggerNodeComponent,
	email: EmailNodeComponent,
	task: TaskNodeComponent,
	emailStep: AutomationStepNodeWrapperComponent,
	actionItemStep: AutomationStepNodeWrapperComponent,
	htmlNewsletterStep: AutomationStepNodeWrapperComponent,
	switchStep: AutomationStepNodeWrapperComponent,
	textingStep: AutomationStepNodeWrapperComponent,
	addTagStep: AutomationStepNodeWrapperComponent,
	removeTagStep: AutomationStepNodeWrapperComponent,
	handwrittenCardStep: AutomationStepNodeWrapperComponent,
	noActionStep: AutomationStepNodeWrapperComponent,
	opportunityStep: AutomationStepNodeWrapperComponent,
	conditionNode: ConditionNodeComponent,
	error: ErrorNodeComponent,
};
